/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { Loading } from "src/libs/useful"
import { isRole } from "src/settings/zustand/user"
import { actions } from "../../data/actions"
import { GET_LOCAL_LANDING_ACTION } from "../../data/actionTypes"
import { IExtendedParams } from "../../data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "../../data/store"
import EditSwitcher from "./landing-edit/EditSwitcher"
import LandingEditor from "./LandingEditor"
import LandingSnapshot from "./LandingSnapshot" 

/** LOCAL SRC landing */
export interface ILandingSnapshotProps {
	extend_params: IExtendedParams
    isAuthor?: boolean
}
const LandingSnapshotForm = (props:ILandingSnapshotProps) :JSX.Element => { 
    //const [isEdit, setIsEdit]		= useState<boolean>(false)    
	const [isLoading, setIsLoading] = useState<boolean>(true)
    const isEdit                    = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit) 
    const currentDimensionEdit      = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    
    const setIsEdit = (bool: boolean) => {
        useLandingConsoleStore.setState({ isEdit: bool })
    }
    useEffect(() => {
        setIsLoading(true)
        actions(
            GET_LOCAL_LANDING_ACTION, 
            {
                id: props.extend_params?.landing_id
            }
        )
        .then(() => {
            setIsLoading(false)

        })
        .catch((err) => {
            setIsLoading(false)
        })
        const layout = document.querySelector("[id='pe-layout-main']")!
        layout.classList.remove("overflow-y-auto")
        layout.classList.add("overflow-hidden") 
        return () => { 
            layout.classList.remove("overflow-hidden")
            layout.classList.add("overflow-y-auto")
        }
    },[ props.extend_params, currentDimensionEdit ])

    

    const is_admin = (): boolean => { 
		return !!props.extend_params.local 
			?
			!!props.extend_params.isEdit
			:
			isRole([ "administrator" ]) || true
	}	
    
    return isLoading
        ?
        <div className="layout-app-state flex-centered">
            <Loading />
        </div>
        :
		<>
			{
				is_admin() && isEdit
					? 
					<LandingEditor   { ...props } isAuthor={ is_admin() } /> 
					: 
					<LandingSnapshot { ...props } isAuthor={ is_admin() } />
			}
			{ 
                is_admin() && 
                <>
                    <EditSwitcher isEdit={isEdit} onSwitch={setIsEdit} />  
                </>    
            }
		</>
	
} 

export default LandingSnapshotForm

